module.exports = __webpack_public_path__ + "img/card_ip_stipulation54.a06a78e1.svg";